import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  Division,
  DivisionWithMatches,
  Format,
  Playoff,
  Progress,
  RoundRobinCompetition,
} from '@pool-league/shared-data-api';
import { HttpErrorResponse } from '@angular/common/http';
import { DivisionKey } from './league.state';

export const divisionDetailsComponentActions = createActionGroup({
  source: 'division-details component',
  events: {
    'load division': props<DivisionKey>(),
    'unload division': emptyProps(),
    'playoff updated': props<{ playoff: Playoff }>(),
  },
});

export const leagueOverviewComponentActions = createActionGroup({
  source: 'league-overview component',
  events: {
    'load divisions': props<{ seasonId: string; format: Format }>(),
  },
});

export const deleteLeagueResultModalActions = createActionGroup({
  source: 'delete league result modal',
  events: {
    'modal closed': emptyProps(),
    'delete result': props<{
      match: {
        seasonId: string;
        format: Format;
        divisionId: number;
        matchNo: number;
      };
    }>(),
  },
});

export const editLeagueResultModalActions = createActionGroup({
  source: 'edit league result modal',
  events: {
    'modal closed': emptyProps(),
    'save result': props<{
      match: {
        seasonId: string;
        format: Format;
        divisionId: number;
        matchNo: number;
        winner: string;
        result: 'F' | number;
      };
    }>(),
  },
});

export const leagueApiActions = createActionGroup({
  source: 'league api',
  events: {
    'league created': props<{
      seasonId: string;
      format: Format;
      details: RoundRobinCompetition;
      divisions: Division[];
    }>(),
    'divisions loading': emptyProps(),
    'divisions load error': props<{ error: HttpErrorResponse | Error }>(),
    'divisions load success': props<{ divisions: Division[] }>(),
    'division loading': emptyProps(),
    'division load success': props<{
      division: DivisionWithMatches;
    }>(),
    'division load error': props<{ error: HttpErrorResponse | Error }>(),
    'delete result request sent': emptyProps(),
    'delete result success': props<{
      division: DivisionWithMatches;
      leagueProgress: Progress;
    }>(),
    'delete result error': props<{ error: HttpErrorResponse | Error }>(),
    'save result request sent': emptyProps(),
    'save result success': props<{
      division: DivisionWithMatches;
      leagueProgress: Progress;
    }>(),
    'save result error': props<{ error: HttpErrorResponse | Error }>(),
  },
});
